import useSettingsService from 'components/hooks/useSettingsService';

const useFF = name => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const value = getSettingOrDefinitionValue({
    name
  });

  return !!value;
};

export default useFF;
